import * as React from 'react';
import { connect } from 'react-redux';
import ClaimsProgressBar from '../ClaimHistoryComponents/ClaimsProgressBar';
import { Card } from 'react-bootstrap';
import { isMobile } from 'react-device-detect';
import { showSwitchToPhone } from '../../../../actions/modalActions';
import { HashLink as Link } from 'react-router-hash-link';
import { CLAIM_HISTORY_V2 } from '../../../../routes/routes';
import '../ClaimHistoryComponents/ClaimHistoryComponents.css'
import { getNextStep, getOverview } from '../../../../actions/claimHistoryActionsV2'
import ClaimsNextStep from '../ClaimHistoryComponents/ClaimsNextStep';

class NotificationOfClaim extends React.Component<any, any> {

    constructor(props) {
        super(props);
        this.state = {
            photoTaken: false
        };
        this.handleClick = this.handleClick.bind(this);
        this.handleToggle = this.handleToggle.bind(this);
        this.handleTakePhoto = this.handleTakePhoto.bind(this);
        this.handleBackClick = this.handleBackClick.bind(this);
    }

    async handleClick() {
        this.props.handleGetNextStep();
    }

    async handleToggle() {
        this.setState({ photoTaken: !this.state.photoTaken });
    }

    async handleTakePhoto() {
        this.props.handleShowSwitchToPhone(this.props.profile.cellphoneNumber)
    }

    async handleBackClick() {
        this.props.handleClaimsBackClick();
    }

    render() {
        const scrollWithOffset = (el) => {
            const yCoordinate = el.getBoundingClientRect().top + window.pageYOffset;
            const yOffset = -90;
            window.scrollTo({ top: yCoordinate + yOffset, behavior: 'smooth' });
        }
        const stepsList = this.props.claimSubmit.claimProgress.claimSteps.filter(x => x.overallEstProgressBar !== null).length > 0
        let nrToUse = -1
        if (this.props.claimSubmit.claimProgress) {
            for (var i = 0; i < this.props.claimSubmit.claimProgress.claimSteps.length - 1; i++) {
                if (this.props.claimSubmit.claimProgress.claimSteps[i + 1].claimStepDescription.toLowerCase() !== this.props.claimSubmit.claimProgress.claimSteps[i].claimStepDescription.toLowerCase()) {
                    nrToUse += 1
                    if (this.props.claimSubmit.claimProgress.claimSteps[i].claimStepDescription.toLowerCase() === this.props.claimSubmit.selectedClaimProgressStep.claimStepDescription.toLowerCase()) {
                        break;
                    }
                }
            }
        }
        const claimStepDescription = this.props.claimSubmit.selectedClaimProgressStep.claimStepDescription.toLowerCase();
        const claimStep = this.props.claimSubmit.claimProgress.claimSteps.filter(x => x.claimStepDescription.toLowerCase() === claimStepDescription)[0];
        return (
            <>
                <button className="claims-back-button" onClick={this.handleBackClick}> <img className="claims-back-button-img" src="/my-policy/Images/Claims/ClaimsV2/Dropdown-arrow-left.png" alt="" title="" />Back</button>
                <div id="NotificationOfClaim">
                    {stepsList && !this.props.claimSubmit.selectedClaimProgressStep.isComplete && claimStepDescription && (claimStep.overallEstCompletionDate || claimStep.overallEstLatestDate) &&
                        <Card className="content-box-padding-20px-with-box-shadow mb-15px">
                            <div className="row noma">
                                <div className="col-12 nopa">
                                    <ClaimsProgressBar />
                                </div>
                            </div>
                        </Card>
                    }
                    <Card className="content-box-padding-20px-with-box-shadow">
                        <>
                            <div className="row noma">
                                <div className="col-12 nopa">
                                    <div className="row noma">
                                        <div className="claims-noc-step-header-icon-area">
                                            {(!this.props.claimSubmit.selectedClaimProgressStep.isComplete) && <img src={"/my-policy/Images/Claims/Numbers/" + nrToUse + "-red.png"} alt={"Step " + nrToUse} title={"Step" + nrToUse} />}
                                            {(this.props.claimSubmit.selectedClaimProgressStep.isComplete) && <img src='/my-policy/Images/Claims/Numbers/step-success-32x32px.svg' alt="" title="" />}
                                        </div>
                                        <div className="col nopa claims-noc-step-header-title-area">
                                            <h3>Notification of claim</h3>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 nopa mt-10px">
                                    {(!this.props.claimSubmit.selectedClaimProgressStep.isComplete) && <p className="font-weight-500 mb-0px">Thanks for notifying us of your claim. We'll contact you soon to get the rest of the info and to register your claim.<br /><br />
                                        {!isMobile &&
                                            <span>Scroll down to the<Link className="text-red" to={CLAIM_HISTORY_V2 + "#claimFAQ"} scroll={el => scrollWithOffset(el)}> <b className="text-underline">FAQ’s</b></Link> for more info.</span>
                                        }
                                        {isMobile &&
                                            <span>Scroll down to the<Link className="text-red"> <b>FAQ’s</b></Link> for more info.</span>
                                        }
                                    </p>}
                                    {(this.props.claimSubmit.selectedClaimProgressStep.isComplete) && <p className="font-weight-500">Thanks for notifying us of your claim. We'll contact you soon to get the rest of the info and to register your claim.</p>}
                                    <hr className="mt-15px mb-15px claims-v2-hr-2px" />
                                </div>
                                <div className="col-12 nopa">
                                    <div className="row noma">
                                        <p className="claim-step-subtitle col-sm-12 col-md-6 col-lg-6 nopa mb-0px noc-step-subtitle">Type of claim</p>
                                        <p className="claim-type col-sm-12 col-md-6 col-lg-6 mb-0 nopa mb-0px">{this.props.claimSubmit.selectedClaim.incident}</p>
                                    </div>
                                    <hr className="mt-15px mb-15px claims-v2-hr-2px" />
                                </div>
                                {false &&
                                    <div className="col-12 nopa">
                                        <p className="claim-step-subtitle mb-10px">Photos of incident (optional)</p>
                                        <p className="mb-10px">If you want to take photos of your car’s/motorbike’s damage, tap below (this isn't mandatory but it will help us process your claim faster)</p>
                                        <div className="noc-take-photo-button-holder">
                                            <button className="take-photo-button take-photo-button-mobile btn-solid-green" onClick={this.handleTakePhoto} id='closeModal'>Take photos</button>
                                        </div>
                                        {this.state.photoTaken &&
                                            <>
                                                <div>
                                                    <p className="claim-step-subtitle">Photos of incident (optional)</p>
                                                    <p>Thanks for adding your photos</p>
                                                </div>
                                                <div className="row ml-1">
                                                    <div className={this.props.isCarHire ? "red-background" : "number-icon text-center"}>
                                                        <div className="icon-checkmark-circle"></div>
                                                    </div>
                                                    <div className="col claim-step-subtitle">
                                                        Photos added
                                            </div>
                                                </div>
                                            </>
                                        }
                                        <hr className="mt-15px mb-15px claims-v2-hr-2px" />
                                    </div>}
                                <div className="col-12 nopa">
                                    <div className="row noma">
                                        <div className="col nopa">
                                            <p className="next-step-subheading mb-0">Next step</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row noma">
                                <div className="col-12 nopa">
                                    <ClaimsNextStep />
                                </div>
                            </div>
                        </>
                    </Card>
                </div >
            </>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        firebase: state.firebase,
        claimSubmit: state.claimSubmit,
        profile: state.profile,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        handleClaimsBackClick: () => dispatch(getOverview()),
        handleGetNextStep: () => dispatch(getNextStep()),
        handleShowSwitchToPhone: (number) => dispatch(showSwitchToPhone(number))
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(NotificationOfClaim);